import React from 'react'
import { useTranslation } from 'react-i18next'
import { flowRight } from 'lodash'
import { graphqlNavHistoryCached, graphqlPrevLocationCached, sliceNavHistory } from 'lib/utils/store/navHistory'
import { withErrorBoundaryNoRender } from 'lib/errorBoundary'
import { matchPath, withRouter } from 'react-router-dom'
import { getLocale } from 'lib/utils/getLocale'

import BackNavigation from './BackNavigation'

const PrevBackNavigation = ({ history, match, navHistory, navHistoryIndex, ...rest }) => {
    const { t, i18n } = useTranslation(['common'])

    let { prevLocation } = rest

    // try to prevent navigation to "child" routes.
    // eg. never back navigate from "/bill-of-sale/:bosId" to "/fiksut-kaupat/sahkoinen-kauppakirja/:bosId/esikatselu" etc.
    if (prevLocation) {
        prevLocation = navHistory && navHistory.slice(1 + navHistoryIndex).find(prevLocation => {
            return !matchPath(prevLocation.match.path, {
                path: match.path,
                exact: false,
                strict: false
            })
        })
    }

    const from = prevLocation
    const fromIndex = from ? navHistory.indexOf(from) : -1

    const useBack = !!from && !!from.pathname
    const text = !useBack || from.pathname === `${getLocale(i18n.language) || '/'}` ? t('common:actions.backToIndex') : t('common:back')

    return (
        <BackNavigation
            to={useBack ? from.pathname : `${getLocale(i18n.language) || '/'}`}
            text={text}
            onClick={(e) => {
                if (fromIndex === 1) {
                    e.preventDefault()
                    history.goBack()
                } else {
                    // We can't use history.goBack() if we wan't to skip (jump back) multiple locations in history.
                    // so we will let the BackNavigation to use "from.pathname" and then we slice the history
                    // as we skip some unwanted locations.
                    sliceNavHistory(fromIndex)
                }
            }}
            {...rest}
        />
    )
}

export default flowRight(
    withErrorBoundaryNoRender,
    graphqlPrevLocationCached,
    graphqlNavHistoryCached,
    withRouter,
)(PrevBackNavigation)
